export const PALLETE_PRIMARY_COLOR = "#191c1f";
export const PALLETE_SECONDARY_COLOR = "#191c1f";
export const BASE_TEXT_COLOR = "#000";
export const BACKGROUND_PRIMARY = "rgba(224, 222, 0,0.9)";
export const BACKGROUND_SECONDARY = "rgba(25, 28, 31,0.45)";
export const PRIMARY = "#E0DE00";
